/**
 * Retorno del proveedor de identidad: canjea el authorization code por los
 * tokens (PKCE) y entra a la consola.
 */

import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '@presentation/context/AuthContext';
import { routes } from '@presentation/router/routes';
import styles from '../admin.module.css';

export function AuthCallbackPage() {
  const { completeLogin } = useAuthContext();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  // El code se canjea una sola vez: en StrictMode el efecto corre dos veces y
  // el segundo intento fallaria con "invalid_grant".
  const exchanged = useRef(false);

  useEffect(() => {
    if (exchanged.current) return;
    exchanged.current = true;

    const run = async () => {
      try {
        await completeLogin();
        navigate(routes.users, { replace: true });
      } catch (cause) {
        setError(cause instanceof Error ? cause.message : 'No se pudo completar el login');
      }
    };

    void run();
  }, [completeLogin, navigate]);

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Ingresando...</h1>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}
